import { contentAi } from '@mi-front/api-clients';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

interface Props {
  content: contentAi.ContentDto;
}

export function FragmentContentLink({ content }: Props) {
  return (
    <Box>
      <Alert severity="info">
        <AlertTitle sx={{ mb: 2 }}>
          <FormattedMessage
            id="contentAi.fragmentContentExists"
            defaultMessage="Ya existe un contenido creado para este fragmento"
          />
        </AlertTitle>
        <Button
          color="inherit"
          variant="outlined"
          component={Link}
          to={`/content-ai/contents/${content.id}`}
          startIcon={<AutoAwesomeIcon />}
        >
          <FormattedMessage id="contentAi.goToContent" defaultMessage="Ir al contenido" />
        </Button>
      </Alert>
    </Box>
  );
}
